import { TOOL_CATEGORIES, toolsForCategory } from "@/components/launch_pad/launchPadConfig";
import { LaunchPadTaskCard } from "@/components/launch_pad/LaunchPadTaskCard";
import type { User } from "@/context/UserProvider";
import type { ActiveSection } from "@/types/appNavigation";

type LaunchPadToolsExplorerProps = {
  user: User;
  onSelect: (section: ActiveSection) => void;
};

export function LaunchPadToolsExplorer({ user, onSelect }: LaunchPadToolsExplorerProps) {
  const categoriesWithTools = TOOL_CATEGORIES.map((category) => ({
    category,
    tools: toolsForCategory(user, category.id),
  }));

  return (
    <div className="space-y-8" data-testid="launch-pad-tools-explorer">
      {categoriesWithTools.map(({ category, tools }) => (
        <div key={category.id}>
          <div className="mb-3">
            <h3 className="text-base font-semibold">{category.label}</h3>
            <p className="text-sm text-muted-foreground">{category.description}</p>
          </div>
          <div className="grid min-w-0 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {tools.map((tool) => (
              <LaunchPadTaskCard
                key={tool.section}
                section={tool.section}
                taskLabel={tool.label}
                description={tool.description}
                icon={tool.icon}
                enabled={tool.isEnabled(user)}
                onSelect={onSelect}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
